import { render, staticRenderFns } from "./platform-score-dialog.vue?vue&type=template&id=623e8c90&scoped=true&"
import script from "./platform-score-dialog.vue?vue&type=script&lang=js&"
export * from "./platform-score-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e8c90",
  null
  
)

export default component.exports